<template>
  <a-form-item :label="data.fieldname">
    <a-input
      v-model="value"
      :type="data.fieldtype ==='number' ? 'number' : 'text' "
      :placeholder="placeholder"
      :disabled="data.disabled"
      class="input"
      @change="handleChange"
    />
  </a-form-item>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: ''
    }
  },
  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    }
  },
  watch: {
    data: {
      handler (val) {
        if (val) {
          this.setDefault()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    // this.setDefault()
  },
  methods: {
    handleChange (e) {
      const { fieldtype = '' } = this.data || {}
      let val = e.target.value
      if (fieldtype === 'phone' || fieldtype === 'email') {
        val = val.split(/[,，\s]+/)
      }
      this.$emit('change', val)
    },
    init () {
      this.setDefault()
    },
    async setDefault () {
      let { fieldvalue = '', fieldtype = '' } = this.data || {}

      if (fieldtype === 'phone' || fieldtype === 'email' || this.$toType(fieldvalue) === 'array') {
        this.value = fieldvalue && fieldvalue.join(',')
      } else {
        this.value = fieldvalue
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style>
</style>
